import React, { Component } from 'react';

class Page extends Component {
  render() {
    const className = this.props.disabled?'w3':(this.props.selected ? 'bg-w1 pointer' : 'pointer pc1');

    return (
      <span className={`dib vpadd5 hpadd10 rad3 ${className}`} onClick={this.props.onClick}>
        {this.props.page}
      </span>
    )
  }
}

export default Page;
